import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=c2a3a564&scoped=true"
import script from "./PersonEdit.vue?vue&type=script&lang=js"
export * from "./PersonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a3a564",
  null
  
)

export default component.exports